




































































import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "../../lib/ajax";
import CourtInstallationModel from "./courtInstallationModel.vue";
class PagecourtInstallationRequest extends PageRequest {
  name: string;
  showOnHome: boolean;
}

@Component({
  components: { CourtInstallationModel },
})
export default class courtInstallations extends AbpBase {
  // 编辑按钮事件处理
  edit(id) {
    this.courtInstallationId = id;
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagecourtInstallationRequest =
    new PagecourtInstallationRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  courtInstallationId: number = null;
  get list() {
    return this.$store.state.courtInstallation.list;
  }
  get loading() {
    return this.$store.state.courtInstallation.loading;
  }
  create() {
    this.courtInstallationId = null;
    this.editModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("courtInstallation/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("courtInstallation/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("courtInstallation/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "courtInstallation/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.courtInstallation.pageSize;
  }
  get totalCount() {
    return this.$store.state.courtInstallation.totalCount;
  }
  get currentPage() {
    return this.$store.state.courtInstallation.currentPage;
  }
  columns = [
    {
      title: "名称",
      key: "name",
      tooltip: true,
    },
    {
      title: "介绍",
      key: "description",
    },
    {
      title: "排序",
      key: "displayOrder",
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      align: "center",
      slot: "action",
      render: (h: any, params: any) => {
        const hasEditPermission = this.hasPermission("Pages.Court.Edit");
        const hasDeletePermission = this.hasPermission("Pages.Court.Delete");
        const buttons = [];
        if (hasEditPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.courtInstallationId = params.row.id;
                    this.$store.commit("courtInstallation/edit", params.row);
                    this.edit(params.row.id);
                  },
                },
              },
              "编辑"
            )
          );
        }
        if (hasDeletePermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: "确定要删除该球场设施吗",
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "courtInstallation/delete",
                          data: params.row,
                        });
                        await this.getpage();
                        this.$Message.success("删除成功");
                      },
                    });
                  },
                },
              },
              "删除"
            )
          );
        }
        return h("div", buttons);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
